import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-month-year-picker',
  template: `
    <div class="row">
      <!-- Month Selection 
       [placeholder]="monthPlaceholder"-->
      <div class="col-sm-6 col-12">
        <!-- <app-month-picker 
          [control]="monthControl"
          
          (monthSelected)="onMonthSelected($event)">
        </app-month-picker> -->
      </div>
      
      <!-- Year Selection 
          [placeholder]="yearPlaceholder"
        -->
      <div class="col-sm-6 col-12">
        <app-year-picker 
          [control]="yearControl"
          (yearSelected)="onYearSelected($event)">
        </app-year-picker>
      </div>
    </div>
  `
})
export class MonthYearPickerComponent implements OnInit {
  @Input() monthControl: FormControl | null = null;
  @Input() yearControl: FormControl | null = null;
  @Input() monthPlaceholder: string = 'Select Month';
  @Input() yearPlaceholder: string = 'Select Year';
  
  @Output() monthSelected = new EventEmitter<number>();
  @Output() yearSelected = new EventEmitter<number>();
  @Output() dateChanged = new EventEmitter<{month: number, year: number}>();

  ngOnInit(): void {
    // Initialize if needed
  }

  onMonthSelected(month: number): void {
    this.monthSelected.emit(month);
    this.emitDateChanged();
  }

  onYearSelected(year: number): void {
    this.yearSelected.emit(year);
    this.emitDateChanged();
  }

  private emitDateChanged(): void {
    const month = this.monthControl?.value;
    const year = this.yearControl?.value;
    
    if (month && year) {
      this.dateChanged.emit({ month, year });
    }
  }
}
